import Browser from '@parameter1/base-cms-marko-web/browser';
import Shared from '@bobit-business-media/package-global/browser';

Shared(Browser);

export default Browser;
